import React, {Fragment, useEffect, useState} from "react";
import localization from "assets/localization/localization";
import Layout from "components/sales/layout/layout";
import DivLayout from "components/sales/divLayout/divLayout";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import Loader from "components/sales/Loader/loader";
import { type } from "jquery";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { DatePickerInput } from "rc-datepicker";
import "./EditServiceInvoice.css";

const finiteOrNull = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const formatLineAmount = (value) => {
  const num = finiteOrNull(value);
  return num === null ? "" : num.toFixed(2);
};

const productAmount = (left, right) => {
  const a = finiteOrNull(left);
  const b = finiteOrNull(right);
  if (a === null || b === null) return "";
  return formatLineAmount(a * b);
};

const declaredMenDaysValue = (quantity, menDays) => {
  const qty = finiteOrNull(quantity);
  const days = finiteOrNull(menDays);
  if (qty === null || days === null) return "";
  return qty * days;
};

const actualExceedsDeclared = (item) => {
  if (item?.variable_type !== "V") return false;
  const actual = Number(item?.meta_data?.actual_total_mandays);
  const declared = Number(item?.meta_data?.expected_total_mandays);
  return (
    Number.isFinite(actual) &&
    Number.isFinite(declared) &&
    actual > declared
  );
};

const variableLineTotal = (item) => {
  const actual = finiteOrNull(item?.meta_data?.actual_total_mandays);
  const unitPrice = finiteOrNull(item?.unit_price);
  if (actual === null || unitPrice === null) return "";
  return (unitPrice * actual).toFixed(2);
};

const LineItemRemark = ({ value, onChange, disabled = false }) => (
  <td className="remark-col">
    <textarea
      className="form-control line-remark"
      rows={3}
      value={value || ""}
      placeholder="Remark"
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    />
  </td>
);

const EditServiceInvoice = ({
  history,
  match,
  getServiceInvoiceList,
  valetContractInvoice = [],
  lineItemsUpdate,
  lineItems = [],
  getServicesOnDemand,
  onDemandServicesList = [],
  lineItemsApprovalRejection,
  convertServiceInvoice,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const [listData, setListData] = useState([{}]);
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState(false);
  const [attachment, setAttachment] = useState("")
  const [poNumber, setPoNumber] = useState("");
  const [remarks, setRemarks] = useState("");
  const [poDate, setPoDate] = useState("");
  let [sum, setSum] = useState(0);
  const [rows, setRows] = useState([]);
  const [isAddDisabled, setIsAddDisabled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [confirmLabel, setConfirmLabel] = useState("Are you sure?");
  const [confirmAction, setConfirmAction] = useState("");
  const [rejectRemark, setRejectRemark] = useState("");
  const newServiceTemplate = {
    description: "",
    item_id: null,
    meta_data: {
      actual_total_mandays: 0,
      expected_unit_mandays: 0,
      expected_total_mandays: 0,
      variable_type: "O",
      is_variable: 0,
    },
    quantity: 0,
    unit_price: 0,
    total_price: 0,
    variable_type: "O",
    remarks: "",
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getServiceInvoiceList(1, 2, null, match?.params?.invoice_id);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    const invoice =
      valetContractInvoice?.resultSets?.find(
        (item) => String(item?.invoice_id) === String(match?.params?.invoice_id)
      ) || null;
    if (!invoice || !Array.isArray(invoice.item_data)) return;
    setListData(invoice.item_data);
    setInvoiceNo(invoice.invoice_number);
    setTimeout(() => {
      setIsLoading(true);
      setIsLoading(false);
    }, 500);
  }, [valetContractInvoice, match?.params?.invoice_id]);

  const handleInput = (key, index, val, isMeta = false) => {
    let list = [...listData];
    const isNumeric =
      key === "actual_total_mandays" ||
      key === "expected_total_mandays" ||
      key === "unit_price" ||
      key === "quantity";

    if (isMeta) {
      list[index] = {
        ...list[index],
        meta_data: {
          ...list[index].meta_data,
          [key]: isNumeric ? Number(val) : val,
        },
      };
    } else {
      list[index][key] = isNumeric ? Number(val) : val;
    }

    if (list[index].variable_type === "V") {
      const total = variableLineTotal(list[index]);
      list[index].total_price = total === "" ? 0 : parseFloat(total);
    }

    setListData(list);
  };

  useEffect(() => {
    let list = [...listData];
    let s = 0;
    const addLineTotal = (total, item) => {
      if (item?.variable_type === "V") {
        const amount = Number(variableLineTotal(item));
        return Number.isFinite(amount) ? total + amount : total;
      }
      if (item?.meta_data?.actual_total_mandays) {
        const quantity = finiteOrNull(item?.quantity);
        const actual = finiteOrNull(item?.meta_data?.actual_total_mandays);
        const unitPrice = finiteOrNull(item?.unit_price);
        const expected = finiteOrNull(item?.meta_data?.expected_total_mandays);
        if (
          quantity === null ||
          actual === null ||
          unitPrice === null ||
          expected === null ||
          expected === 0
        ) {
          return total;
        }
        return total + Number(((quantity * actual * unitPrice) / expected).toFixed(2));
      }
      const amount = Number(productAmount(item?.quantity, item?.unit_price));
      return Number.isFinite(amount) ? total + amount : total;
    };

    list.forEach((item) => {
      s = addLineTotal(s, item);
    });
    rows.forEach((item) => {
      s = addLineTotal(s, item);
    });
    setSum(s);
  }, [listData, rows]);

  // useEffect(() => {
  //   if (parseInt(lineItems?.status_code) !== 200) {
  //     toast.error(lineItems?.message);
  //   }
  //   // else {
  //   //   toast.success(lineItems?.response?.message);
  //   // }
  // }, [lineItems]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      getServicesOnDemand();
      setIsLoading(false);
    })();
  }, []);

  const addService = () => {
    setRows([...rows, newServiceTemplate]);
    setIsAddDisabled(true);
  };

  const removeService = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    if (updatedRows.length === 0) setIsAddDisabled(false);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) => {
      if (i === index) {
        let updatedRow = { ...row };

        updatedRow[field] =
          field === "quantity" || field === "unit_price"
            ? parseFloat(value) || 0
            : value;

        if (field === "quantity" || field === "unit_price") {
          updatedRow.total_price =
            (updatedRow.quantity || 0) * (updatedRow.unit_price || 0);
        }

        return updatedRow;
      }
      return row;
    });

    setRows(updatedRows);
  };

  const currentInvoice =
    valetContractInvoice?.resultSets?.find(
      (item) => String(item?.invoice_id) === String(match?.params?.invoice_id)
    ) || null;
  const invoiceStage = currentInvoice?.invoice_stage;
  const roleId = Number(localStorage.getItem("fusion-role"));
  const isFinanceApprover = roleId === 13 || roleId === 49;
  const showEditButton = Number(currentInvoice?.is_editable) === 1;
  const showApprovedButton = currentInvoice != null && invoiceStage == null;
  const showFinanceActions =
    invoiceStage === "FINANCE_PENDING" && isFinanceApprover;

  const handleEditInvoice = () => {
    setIsEditing(true);
    setTimeout(() => {
      document.getElementById("service-line-items")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 0);
  };

  const openConfirm = (action, label) => {
    setConfirmAction(action);
    setConfirmLabel(label);
    setRejectRemark("");
    setIsModal(true);
  };

  const handleApproveInvoice = () => {
    openConfirm("convert", "Are you sure to convert this PI to TI?");
  };

  const handleFinanceApprove = () => {
    openConfirm("approve", "Are you sure to approve?");
  };

  const handleFinanceReject = () => {
    openConfirm("reject", "Are you sure to reject?");
  };

  const handleConvertInvoice = async (action = "convert") => {
    const invoiceId = Number(match?.params?.invoice_id);
    if (!Number.isFinite(invoiceId)) {
      toast.error("Invoice id is missing");
      return;
    }

    setIsLoading(true);
    setIsModal(false);
    try {
      const convertAction = {
        convert: "DIRECT_APPROVE",
        approve: "FINANCE_APPROVED",
        reject: "FINANCE_REJECT",
      }[action];
      const res = await convertServiceInvoice(
        invoiceId,
        convertAction,
        action === "reject" ? rejectRemark : undefined
      );
      const isSuccess =
        Number(res?.status) === 0 ||
        (Number(res?.status_code) === 200 && res?.response?.status === true);

      if (isSuccess) {
        toast.success(res?.message || res?.response?.message || "Success");
        history.push("/dashboard/variable-service-invoice-list");
      } else if (Number(res?.status) !== 1) {
        toast.error(res?.message || res?.response?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error converting invoice:", error);
      toast.error("Something went wrong");
    }
    setIsLoading(false);
  };

  const handleConfirmSubmit = async () => {
    let isValidated = true;
    let msg = "";
    listData.map((val) => {
      // if (
      //   (val?.meta_data?.actual_total_mandays > 31)
      // ) {
      //   msg =
      //     "Men days can't be greater than 31 and less than 0 for item " +
      //     val?.description;
      //   isValidated = false;
      // }

      if (actualExceedsDeclared(val)) {
        msg =
          "Actual Men days can't be greater than Declared Men days for item " +
          val?.description;
        isValidated = false;
      }

      if (val?.unit_price <= 0) {
        msg = "Amount can't be in -ve and 0 for item " + val?.description;
        isValidated = false;
      }

      if (val?.quantity <= 0) {
        msg = "Quantity can't be in -ve and 0 for item " + val?.description;
        isValidated = false;
      }
      if (val?.remarks?.length > 15) {
        msg = "Remark can't be more than 15 characters for item ";
        toast.warning(msg);
        return false;
      }
    });

    const submitData = {
      line_items: listData.map((item) => {
        if (item?.variable_type !== "V") return item;
        const total = variableLineTotal(item);
        return {
          ...item,
          total_price: total === "" ? 0 : parseFloat(total),
        };
      }),
      row_data: rows ?? [],
      invoice_id: match?.params?.invoice_id,
      invoice_no: invoiceNo,
      action: 2,
      installment_invoice_id: match?.params?.invoice_id,
      installment_type: match?.params?.installment_type,
      po_number: poNumber ?? '',
      remarks: remarks ?? '',
      attachment: attachment ?? '',
      po_date: poDate ?? '' 
    };

    if (!isValidated) {
      toast.warning(msg);
      return false;
    }

    const poNumberTrimmed = (submitData.po_number ?? '').trim();
    const poDateValue = submitData.po_date ?? '';

    if ((poNumberTrimmed && !poDateValue) || (!poNumberTrimmed && poDateValue)) {
      toast.error("Both PO Number and PO Date must be provided together.");
      return false;
    }
   
    setIsLoading(true);
    setIsModal(false);
    try {
      const res = await lineItemsApprovalRejection(submitData);
      const isSuccess =
        Number(res?.status_code) === 200 &&
        res?.status !== false &&
        res?.response?.status !== false;

      if (isSuccess) {
        toast.success(res?.response?.message || res?.message || "Success");
        history.push('/dashboard/variable-service-invoice-list');
      } else {
        toast.error(res?.response?.message || res?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error updating line items:", error);
      toast.error("Something went wrong");
    }
    setIsLoading(false);
  };

  const handlePoDateChange = (jsdate, dateString) => {
    setPoDate(dateString);
  };

  const handleModalHide = () => {
    setIsModal(false);
    setRejectRemark("");
  };

  const handleModalYes = () => {
    if (confirmAction === "reject" && !rejectRemark.trim()) {
      toast.error("Remark is required");
      return;
    }
    if (confirmAction === "convert" || confirmAction === "approve" || confirmAction === "reject") {
      handleConvertInvoice(confirmAction);
      return;
    }
    setIsModal(false);
    setRejectRemark("");
  };

  const headerBtns = () => {
    if (!showEditButton && !showApprovedButton && !showFinanceActions) return null;
    return (
      <Fragment>
        {!showFinanceActions && showEditButton && !isEditing && (
          <Button
            onClick={handleEditInvoice}
            className="filter-hamburger btn btn-transparent"
          >
            Edit
          </Button>
        )}
        {!showFinanceActions && showApprovedButton && !isEditing && (
          <Button
            onClick={handleApproveInvoice}
            className="filter-hamburger btn btn-transparent"
          >
            Convert to TI
          </Button>
        )}
        {showFinanceActions && !isEditing && (
          <Button
            onClick={handleFinanceApprove}
            className="filter-hamburger btn btn-transparent"
          >
            Approve
          </Button>
        )}
        {showFinanceActions && !isEditing && (
          <Button
            onClick={handleFinanceReject}
            className="filter-hamburger btn btn-transparent"
          >
            Reject
          </Button>
        )}
      </Fragment>
    );
  };

  return (
    <>
    <Loader isLoading={isLoading}></Loader>
      <Layout
        title={"Service Line Item"}
        isLoading={isLoading}
        isGoback={true}
        Buttons={headerBtns}
      >
        
        {valetContractInvoice &&
          valetContractInvoice?.resultSets &&
          valetContractInvoice?.resultSets.length > 0 && (
            <>
              <div className="panel-card card-details" width="100%">
                <div className="panel-heading">
                  {localization.invoiceModule}
                </div>
                <div className="panel-body">
                  <div className="details-listing detail_alignment">
                    <DivLayout
                      heading={"Invoice Id"}
                      data={valetContractInvoice?.resultSets[0]?.invoice_id}
                    />
                    <DivLayout
                      heading={"Invoice Number"}
                      data={valetContractInvoice?.resultSets[0]?.invoice_number}
                    />
                    <DivLayout
                      heading={"Invoice Date"}
                      data={valetContractInvoice?.resultSets[0]?.invoice_date}
                    />
                    <DivLayout
                      heading={"Invoice Type"}
                      data={
                        valetContractInvoice?.resultSets[0]?.invoice_type === 1
                          ? "Pre"
                          : "Post"
                      }
                    />
                    <DivLayout
                      heading={"Net Payable"}
                      data={valetContractInvoice?.resultSets[0]?.net_payable}
                    />
                  </div>
                </div>
              </div>
              <div id="service-line-items" className="panel-card card-details service-line-items" width="100%">
                <div className="panel-heading">{localization.lineItem}</div>
                <div className="panel-body">
                  <div className="details-listing detail_alignment line-item-scroll">
                    <table className="table line-item-table">
                      <thead>
                        <tr>
                          <th className="item-col">Item</th>
                          <th>Type</th>
                          <th>Quantity</th>
                          <th>Unit Price</th>
                          <th>Actual Men days (Shown on Variable Only)</th>
                          <th>Declared Men Days (Not shown on TI)</th>
                          <th>Total Price</th>
                          <th className="remark-col">Remark</th>
                          <th className="line-remove-col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {listData !== undefined &&
                          listData.length > 0 &&
                          listData.map((val, i) => {
                            return (
                              <>
                                {val?.variable_type === "O" && (
                                  <>
                                    <tr>
                                      <td>{val?.description}</td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            label={localization.revenueType}
                                            value={"On Demand"}
                                            type="text"
                                            handleChange={(value) => () => {}}
                                            disabled={true}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            label={localization.quantity}
                                            value={val.quantity}
                                            type="numnber"
                                            disabled={!isEditing}
                                            handleChange={(value) =>
                                              handleInput("quantity", i, value)
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            label={localization.unitPrice}
                                            value={val.unit_price}
                                            type="text"
                                            disabled={!isEditing}
                                            handleChange={(values) =>
                                              handleInput(
                                                "unit_price",
                                                i,
                                                values
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            // label={"Present Men Days"}
                                            value={val.Present}
                                            type="text"
                                            handleChange={(values) =>
                                              handleInput(
                                                "actual_total_mandays",
                                                i,
                                                values
                                              )
                                            }
                                            disabled={true}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            value={declaredMenDaysValue(
                                              val?.quantity,
                                              val?.men_days
                                            )}
                                            type="text"
                                            handleChange={(value) => () => {}}
                                            disabled={true}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            value={productAmount(
                                              val.quantity,
                                              val.unit_price
                                            )}
                                            type="text"
                                            handleChange={(value) => () => {}}
                                            disabled={true}
                                          />
                                        </div>
                                      </td>
                                      <LineItemRemark
                                        value={val?.remarks}
                                        disabled={!isEditing}
                                        onChange={(value) =>
                                          handleInput("remarks", i, value)
                                        }
                                      />
                                    </tr>
                                  </>
                                )}
                                {val?.variable_type === "V" && (
                                  <tr>
                                    <td>{val?.description}
                                    <br/>
                                      <strong>Present Days:
                                      {val?.role_present_days}</strong>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          label={localization.revenueType}
                                          value={"Variable"}
                                          type="text"
                                          handleChange={(value) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          label={localization.quantity}
                                          value={val?.quantity}
                                          type="number"
                                          handleChange={(value) =>
                                            handleInput("quantity", i, value)
                                          }
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          label={localization.unitPrice}
                                          value={parseFloat(val.unit_price).toFixed(2)}
                                          type="text"
                                          handleChange={(values) =>
                                            handleInput("unit_price", i, values)
                                          }
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    {(currentInvoice?.billing_type ?? valetContractInvoice?.resultSets?.[0]?.billing_type) == 1 ? (
                                      <>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            label={"Actual Men days"}
                                            value={
                                              val?.meta_data?.actual_total_mandays
                                            }
                                            type="text"
                                            errorMsg="Can't be greater than declared men days"
                                            blockError={actualExceedsDeclared(val)}
                                            disabled={!isEditing}
                                            handleChange={(values) =>
                                              handleInput(
                                                "actual_total_mandays",
                                                i,
                                                values,
                                                true
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="col-sm-12">
                                          <ConstantInput
                                            label={"Declared Men Days"}
                                            value={
                                              val?.meta_data
                                                ?.expected_total_mandays
                                            }
                                            type="text"
                                            handleChange={(values) =>
                                              handleInput(
                                                "expected_total_mandays",
                                                i,
                                                values,
                                                true
                                              )
                                            }
                                            disabled={true}
                                          />
                                        </div>
                                      </td>
                                      </>
                                    ) : (
                                      <>
                                        <td>
                                          <div className="col-sm-12">
                                            <ConstantInput
                                              label={"Actual Men days"}
                                              value={
                                                val?.meta_data?.actual_total_mandays
                                              }
                                              type="text"
                                              errorMsg="Can't be greater than declared men days"
                                              blockError={actualExceedsDeclared(val)}
                                              disabled={!isEditing}
                                              handleChange={(values) =>
                                                handleInput(
                                                  "actual_total_mandays",
                                                  i,
                                                  values,
                                                  true
                                                )
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="col-sm-12">
                                            <ConstantInput
                                              label={"Declared Men Days"}
                                              value={
                                                val?.meta_data
                                                  ?.expected_total_mandays
                                              }
                                              type="text"
                                              handleChange={(values) =>
                                                handleInput(
                                                  "expected_total_mandays",
                                                  i,
                                                  values,
                                                  true
                                                )
                                              }
                                              disabled={!isEditing}
                                            />
                                          </div>
                                        </td>
                                      </>
                                    )}
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          value={variableLineTotal(val)}
                                          handleChange={(value) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <LineItemRemark
                                      value={val?.remarks}
                                      disabled={!isEditing}
                                      onChange={(value) =>
                                        handleInput("remarks", i, value)
                                      }
                                    />
                                  </tr>
                                )}
                                {val?.variable_type === "F" && (
                                  <tr>
                                    <td>{val?.description}</td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          label={localization.revenueType}
                                          value={"Fixed"}
                                          type="text"
                                          handleChange={(value) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          label={localization.quantity}
                                          value={val?.quantity}
                                          type="number"
                                          handleChange={(value) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          label={localization.unitPrice}
                                          value={parseFloat(val.unit_price).toFixed(2)}
                                          type="text"
                                          handleChange={(values) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          // label={"Present Men Days"}
                                          // value={val.men_days}
                                          type="text"
                                          handleChange={(values) =>
                                            handleInput(
                                              "actual_total_mandays",
                                              i,
                                              values
                                            )
                                          }
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          // label={"Total Men Days"}
                                          // value={val?.quantity * val?.men_days}
                                          type="text"
                                          handleChange={(value) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="col-sm-12">
                                        <ConstantInput
                                          value={productAmount(
                                            val?.quantity,
                                            val.unit_price
                                          )}
                                          type="text"
                                          handleChange={(value) => () => {}}
                                          disabled={true}
                                        />
                                      </div>
                                    </td>
                                    <LineItemRemark
                                      value={val?.remarks}
                                      disabled={!isEditing}
                                      onChange={(value) =>
                                        handleInput("remarks", i, value)
                                      }
                                    />
                                  </tr>
                                )}
                              </>
                            );
                          })}
                        {/* {console.log("Services:", servicesList)} */}
                        {rows.map((row, index) => (
                          <tr key={index}>
                            <td className="service-picker">
                              <DropDownInput
                                data={onDemandServicesList}
                                label={"Description"}
                                required
                                errorMsg={localization.requiredName}
                                getIdValue={(val) =>
                                  handleInputChange(index, "item_id", val.id)
                                }
                              />
                            </td>
                            <td>
                              <div className="col-sm-12">
                                <ConstantInput
                                  label={localization.revenueType}
                                  value="On Demand"
                                  type="text"
                                  handleChange={() => {}}
                                  disabled
                                />
                              </div>
                            </td>
                            <td>
                              <div className="col-sm-12">
                                <ConstantInput
                                  label={localization.quantity}
                                  value={row.quantity || 0}
                                  type="number"
                                  handleChange={(value) =>
                                    handleInputChange(index, "quantity", value)
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <div className="col-sm-12">
                                <ConstantInput
                                  label={localization.unitPrice}
                                  value={parseFloat(row.unit_price).toFixed(2)}
                                  type="text"
                                  handleChange={(value) =>
                                    handleInputChange(
                                      index,
                                      "unit_price",
                                      value
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <div className="col-sm-12">
                                <ConstantInput
                                  // label="Present Men Days"
                                  value={row.present || ""}
                                  type="text"
                                  handleChange={() => {}}
                                  disabled
                                />
                              </div>
                            </td>
                            <td>
                              <div className="col-sm-12">
                                <ConstantInput
                                  value={declaredMenDaysValue(
                                    row.quantity,
                                    row.present
                                  )}
                                  type="text"
                                  handleChange={() => {}}
                                  disabled
                                />
                              </div>
                            </td>
                            <td>
                              <div className="col-sm-12">
                                <ConstantInput
                                  value={productAmount(row.quantity, row.unit_price)}
                                  type="text"
                                  handleChange={() => {}}
                                  disabled
                                />
                              </div>
                            </td>
                            <LineItemRemark
                              value={row.remarks}
                              onChange={(value) =>
                                handleInputChange(index, "remarks", value)
                              }
                            />
                            <td className="line-remove">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removeService(index)}
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ))}

                        <tr className="sum-row">
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>Sum</td>
                          <td>{Number.isFinite(sum) ? sum.toFixed(2) : "0.00"}</td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {isEditing && (
                    <div className="line-item-actions">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={addService}
                      >
                        Add Services
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {isEditing && (
              <div className="panel-card card-details po-details">
                <div className="panel-heading">PO Details</div>
                <div className="panel-body">
                  <div className="po-details-grid">
                    <div className="po-field">
                      <label className="po-field-label" htmlFor="po-number">
                        PO Number
                      </label>
                      <input
                        id="po-number"
                        className="form-control"
                        type="text"
                        value={poNumber}
                        placeholder="PO Number"
                        onChange={(event) => setPoNumber(event.target.value)}
                      />
                    </div>
                    <div className="po-field po-date">
                      <label className="po-field-label">PO Date</label>
                      <DatePickerInput
                        onChange={handlePoDateChange}
                        value={poDate}
                        placeholder="PO Date"
                        autoClose
                        closeOnClickOutside
                        showOnInputClick
                        locale="en"
                        className="my-custom-datepicker-component"
                        displayFormat="YYYY-MM-DD"
                        returnFormat="YYYY-MM-DD"
                      />
                    </div>
                    <div className="po-field po-attachment">
                      <label className="po-field-label">Attachment</label>
                      <FileUpload
                        id="attachment"
                        accept=".pdf,.png,.jpg,.jpeg,.xlsx,.csv"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={(val) => setAttachment(val)}
                      >
                        <span className="btn btn-transparent">
                          {localization.attachment}
                        </span>
                      </FileUpload>
                    </div>
                  </div>
                  <div className="po-field po-remarks">
                    <label className="po-field-label" htmlFor="invoice-remarks">
                      Remarks
                    </label>
                    <textarea
                      id="invoice-remarks"
                      className="form-control"
                      rows={4}
                      placeholder="Remarks"
                      value={remarks}
                      onChange={(event) => setRemarks(event.target.value)}
                    />
                  </div>
                  <div className="po-submit">
                    <Button onClick={handleConfirmSubmit}>
                      {localization.submitDtl}
                    </Button>
                  </div>
                </div>
              </div>
              )}
            </>
          )}
        <ModalPop
          title={localization.conf}
          show={isModal}
          handleModalHide={handleModalHide}
          modalSize="compact"
          dialogClassName="convert-confirm-dialog"
        >
          <div className="convert-confirm">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <p className="convert-confirm__message">{confirmLabel}</p>
            {confirmAction === "reject" && (
              <div className="convert-confirm__remark">
                <label htmlFor="reject-remark">Remark</label>
                <textarea
                  id="reject-remark"
                  className="form-control"
                  rows={3}
                  placeholder="Remark"
                  value={rejectRemark}
                  onChange={(event) => setRejectRemark(event.target.value)}
                />
              </div>
            )}
            <div className="convert-confirm__actions">
              <Button
                onClick={handleModalHide}
                className="convert-confirm__btn convert-confirm__no"
              >
                {localization.no}
              </Button>
              <Button
                onClick={handleModalYes}
                className="convert-confirm__btn convert-confirm__yes"
              >
                {localization.yes}
              </Button>
            </div>
          </div>
        </ModalPop>
      </Layout>
    </>
  );
};

export default EditServiceInvoice;
